<template>
  <div class="wrp">
    <div class="submitCode"><i class="huixiaopiaofont" @click="submitData">&#xe601;</i></div>
    <div class="swiper-wrp">
      <van-swipe v-if="!loading" :autoplay="3000" style="height: 100%" :initial-swipe="1" indicator-color="white">
        <van-swipe-item v-for="(img, index) in swiperList" :key="index">
          <img :src="img" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="money-wrp">
      <div class="title">
        <p>开票金额￥</p>
        <p>{{today}}</p>
      </div>
      <van-cell-group v-show="moneyIptShow" :border="false" class="money">
        <van-field
          type="number"
          v-model="editData.money"
          ref="moneyIpt"
          @blur="inputBlur"
        >
          <i v-if="editData.money.length > 0" @click="clearMoney" class="huixiaopiaofont clear" slot="button">&#xe632;</i>
        </van-field>
      </van-cell-group>
      <div class="money money-value" v-if="!moneyIptShow">
        <p @touchstart="moneyValueHandle" v-if="editData.money.length > 0">{{convertNumber(editData.money)}}</p>
        <p @touchstart="moneyValueHandle" class="please" v-if="!(editData.money.length > 0)">请输入开票金额</p>
        <i v-if="editData.money.length > 0" @click="clearMoney" class="huixiaopiaofont clear" slot="button">&#xe632;</i>
      </div>
    </div>
    <div class="detail-wrp">
      <!-- <i class="huixiaopiaofont qrcode-btn" @click="submitData">&#xe601;</i> -->
      <div class="select-btn" @click="toSelect">
        <p>{{editData.type === 1 ? '商品大类' : '商品明细'}}</p>
        <i class="huixiaopiaofont">&#xe777;</i>
      </div>
      <div class="detail-list-wrp">
        <div class="detail-title">
          <span class="name">名称</span>
          <span class="count">数量</span>
          <span class="sum">合计</span>
        </div>
        <div class="detail-item" v-for="(item, index) in detailList" :key="index">
          <span class="name">{{item.name}}</span>
          <span class="count">{{item.count}}</span>
          <span class="sum">{{convertNumber(item.sum)}}</span>
        </div>
      </div>
    </div>
    <van-popup
      v-model="qrcodeData.qrcodeShow"
    >
      <div class="qrcode-modal-wrp">
        <div class="title">
          <p>扫码开票</p>
          <i @click="qrcodeData.qrcodeShow = false" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="qrcode-img-wrp">
          <VueQrcode class="qrcode" :value="this.qrcodeData.qrcodeImg" :options="{size:500}"></VueQrcode>
        </div>
        <div class="modal-money-wrp">
          <p>发票金额：</p>
          <p style="color: #4573DE">{{convertNumber(editData.money)}}</p>
        </div>
        <p class="modal-tips">电子发票默认推送至客户指定邮箱，如需手机获取，请先加入微信公众号。</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  NumberKeyboard,
  Field,
  CellGroup,
  Popup,
  Notify,
  Toast
} from 'vant'
import moment from 'moment'
import {
  ConvertNumber,
  deepCopy,
  localStorage,
  onCount
} from '@utils/basicUtil'
import VueQrcode from '@xkeshi/vue-qrcode'
import { officialAccountRequest } from '@services'

export default {
  props: ['loading'],
  data: () => ({
    swiperList: [
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner1.png',
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner2.png',
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner3.png'
    ],
    today: '',
    moneyIptShow: false,
    pleaseShow: true,
    qrcodeData: {
      qrcodeShow: false,
      qrcodeImg: ''
    },
    userId: '',
    detailSum: 0
  }),
  computed: {
    moneyIpt () {
      return this.$refs['moneyIpt']
    },
    detailList () {
      return this.$store.state.business.detailList
    },
    editData () {
      return this.$store.state.business.editData
    }
  },
  mounted () {
    this.initToday()
    this.getUserId()
    this.isLogin()
    this.getCompany()
  },
  methods: {
    isLogin () {
      const token = localStorage.get('X-Access-Token')
      if (!token) {
        this.$router.push(`/invoice/business/login`)
      }
    },
    async getCompany () {
      const data = await officialAccountRequest.getCompany.getCompany({}, {})
      if (data.success) {
        this.$store.commit('business/changeCompanyInfo', data.result)
      }
    },
    async getUserId () {
      const data = await officialAccountRequest.getUserId.getUserId({})
      if (data.success) {
        this.userId = data.result.id
      }
    },
    inputBlur () {
      this.$store.commit('business/changeEditDataMoney', this.editData.money.length > 0 ? Number(this.editData.money).toFixed(2) : this.editData.money = '')
      this.moneyIptShow = false
      const list = deepCopy(this.$store.state.business.detailList)
      if (Array.isArray(list) && list.length === 0) {

      } else {
        this.equalMoney()
      }
    },
    async submitData () {
      if (this.editData.money.length < 1) {
        return Notify({ type: 'danger', message: '请先填写金额' })
      } else if (!this.detailList.length) {
        return Notify({ type: 'danger', message: '请选择商品大类' })
      }

      Toast.loading({
        massage: '二维码生成中...',
        duration: 0
      })
      const arr = deepCopy(this.detailList)
      this.selectList = deepCopy(this.$store.state.business.detailList)
      arr.forEach((v, i) => {
        v.amountWithTax = Number(Number(v.sum).toFixed(2))
        v.productName = v.goodsName
        v.productCode = v.goodsCode
        v.quantity = v.count
        v.price = v.unitPriceWithTax
        v.specification = v.specificationType
        v.unit = v.measurementUnit
        // delete v.price
      })
      const postData = {
        invoiceReqeustBackDetailvos: arr,
        amountWithTax: this.editData.money,
        userId: this.userId
      }
      try {
        const newData = await officialAccountRequest.qrcode.createInvoice(postData)
        if (newData.success) {
          this.qrcodeData.qrcodeImg = `http://${window.location.host}/invoice/customer?orderId=${newData.result.orderNo}&userId=${this.userId}`
          this.qrcodeData.qrcodeShow = true
        }
      } catch (err) {
        if (err.success === false) {
          Notify({ type: 'danger', message: err.message })
        }
      }
      Toast.clear()
    },
    initToday () {
      this.today = moment().format('YYYY/MM/DD')
    },
    clearMoney () {
      this.$store.commit('business/changeEditDataMoney', '')
      this.$store.commit('business/changeDetailList', [])
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    moneyValueHandle () {
      this.moneyIptShow = true
      this.moneyIpt.focus()
    },
    toSelect () {
      /* if (this.editData.money.length < 1) {
        return Notify({ type: 'danger', message: '请先填写金额' })
      } */
      this.$router.push(`/invoice/business/select?sum=${Number(this.editData.money)}`)
    },
    equalMoney () {
      const arr = deepCopy(this.$store.state.business.detailList)
      arr.forEach((v, i) => {
        this.detailSum += Number(v.sum)
      })
      let diff = Number(onCount.sub(Number(this.editData.money), this.detailSum))
      if (diff > 0 || diff === 0) {
        let itemDif = Number(onCount.div(diff, this.detailList.length).toFixed(2))
        let sumDif = 0
        for (let i = 0; i < this.detailList.length - 1; i++) {
          this.detailList[i].sum = onCount.add(Number(Number(this.detailList[i].sum).toFixed(2)), Number(itemDif))
          sumDif = Number(onCount.add(Number(this.detailList[i].sum), Number(sumDif)))
        }
        this.detailList[this.detailList.length - 1].sum = Number(onCount.sub(Number(this.editData.money), sumDif))
      } else {
        let sumDif = 0
        for (let i = 0; i < this.detailList.length - 1; i++) {
          let bili = onCount.div(Number(this.detailList[i].sum), Number(this.detailSum))
          let itemSum = onCount.mul(bili, Number(this.editData.money))
          this.detailList[i].sum = Number(itemSum.toFixed(2))
          sumDif = Number(onCount.add(Number(this.detailList[i].sum), Number(sumDif)))
        }
        let lastDif = Number(Number(onCount.sub(Number(this.editData.money), Number(sumDif))).toFixed(2))
        if (lastDif < 0) {
          for (let i = 0; i < this.detailList.length; i++) {
            if (this.detailList[i].sum > Math.abs(lastDif)) {
              this.detailList[i].sum += lastDif
              break
            }
          }
        } else {
          this.detailList[this.detailList.length - 1].sum = lastDif
        }
      }
      this.$store.commit('business/changeDetailList', this.detailList)
    }
  },
  components: {
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    VueQrcode
  }
}
</script>

<style lang="less" scoped>
  .wrp {
    height: 100%;
    width: 100%;
    overflow: auto;
    .submitCode {
      z-index: 2000;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      color: #4573DE;
      background-color: #fff;
      border:1px solid rgba(220,220,220,1);
      box-shadow:0px 5px 16px 0px rgba(51,51,51,0.09);
      text-align: center;
      line-height: 130px;
      position: fixed;
      right: 8%;
      bottom: 15%;
      i {
        font-size: 80px;
      }
    }
    .swiper-wrp {
      height: 260px;
      width: 100%;
      overflow: hidden;
      img {
        height: auto;
        width: 100%;
      }
    }
    .money-wrp {
      padding: 0 60px;
      height: 270px;
      background: #fff;
      overflow: hidden;
      margin-top: 10px;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 32px;
        height: 40px;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
        margin-top: 44px;
        overflow: hidden;
        p {
          width: fit-content;
          overflow: hidden;
          height: 100%;
          font-weight: lighter
        }
      }
      .money-value {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: rgba(0,0,0,1) !important;
        height: 106px;
        line-height: 106px;
        margin-top: 40px !important;
        width: 100%;
        overflow: visible;
        p {
          font-size: 100px;
          color: #323233;
          font-weight: bold;
          min-width: 500px;
          min-height: 100px;
          overflow: hidden;
          white-space: nowrap;
        }
        .please{
          color: rgba(153, 153, 153, 0.8);
          font-size: 36px;
          font-weight: 400;
        }
      }
      .money {
        width: 100%;
        border: none;
        padding: 0;
        margin-top: 20px;
        vertical-align: middle;
        overflow: visible;
        .clear {
          color: #DAD9D9;
          font-size: 40px;
        }
        .van-cell {
          font-size: 100px;
          font-weight: bold;
          line-height: 0;
          padding: 0;
          .van-cell__value {
            .van-field__body {
              .van-field__control {
                color: rgba(0,0,0,1) !important;
                height: 106px;
                line-height: 106px;
              }
            }
          }
        }
      }
    }
    .detail-wrp {
      // height: 640px;
      height: calc(100% - 530px);
      padding: 0 60px;
      background: #fff;
      overflow: hidden;
      overflow-y: auto;
      margin-top: 10px;
      -webkit-overflow-scrolling: touch;
      position: relative;
      .detail-list-wrp {
        width: 100%;
        height: calc(100% - 130px);
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        .detail-title {
          font-size: 28px;
          font-weight: 500;
          color: rgba(0,0,0,1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          margin-bottom: 35px;
        }
        .detail-item {
          font-size: 26px;
          font-weight: 400;
          color: rgba(153, 153, 153, 0.8);
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 21px;
          letter-spacing: 2px;
        }
        .detail-item:last-child {
          margin-bottom: 100px;
        }
        .name {
          width: 45%;
          height: 100%;
        }
        .sum {
          width: 35%;
          height: 100%;
          text-align: right;
        }
        .count {
          width: 20%;
          height: 100%;
          text-align: center;
        }
      }
      .qrcode-btn {
        color: #4573DE;
        font-size: 100px;
        position: absolute;
        top: 441px;
        right: 80px;
        font-weight: 300;
        z-index: 99;
      }
      .select-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size:32px;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:100px;
        height: 100px;
        margin-bottom: 20px;
        border-bottom: 0.01067rem solid #eee;
        p {
          letter-spacing: 2px;
        }
      }
      .detail-tit {
        font-size: 32px;
        font-weight: bold;
        color: rgba(0,0,0,1);
        margin-top: 22px;
        margin-left: 50px;
      }
    }
    .qrcode-modal-wrp {
      width: 465px;
      padding: 39px 90px 90px 90px;
      overflow: visible;
      min-height: 620px;
      .title {
        font-size: 32px;
        font-weight:bold;
        color:rgba(0,0,0,1);
        display: flex;
        width: 520px;
        justify-content: space-between;
        align-items: center;
        margin-left: -28px;
        letter-spacing: 2px;
        i {
          color: #DAD9D9;
          font-size: 0.9rem;
        }
      }
      .qrcode-img-wrp {
        width: 100%;
        // height: 414px;
        overflow: visible;
        margin-top: 30px;
        .qrcode {
          width: 100%;
          height: 100%;
        }
      }
      .modal-money-wrp {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 32px;
        font-weight: 500;
        color:rgba(0,0,0,1);
        margin-top: 25px;
      }
      .modal-tips {
        font-size:24px;
        font-weight:400;
        color:rgba(0,0,0,0.5);
        line-height:45px;
        margin-top: 20px;
      }
    }
  }
</style>
